import {DataFetcher} from '@aboutyou/data-fetcher';
import type {ImagesSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {useRouteEntities} from '@aboutyou/router';
import {SkeletonBlock} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {isProductTileEntities} from '../../../features/ProductTile/isProductTileEntities';
import type {ProductTileEntities} from '../../../features/ProductTile/types';
import {useImagesSection} from '../ProductInformationBox/MiniArticleDetail/useGetMinimalProductBulkSection';
import {
  IProductImageSliderViewProps,
  ProductTileImageSliderView,
} from './ProductTileImageSliderView';

export const ProductTileImageSlider: FC<
  IProductImageSliderViewProps & {
    productId: number;
    /**
     * Prevents showing the default state instead of the loading state.
     * The default state is an optimization related to the category page to ADP navigation,
     * to show already fetched data from the category page on the ADP.
     * For example, this is skipped in case we show this component within the mini ADP dialog.
     */
    skipDefaultState?: boolean;
  }
> = props => {
  const entities =
    useRouteEntities<ProductTileEntities>() as ProductTileEntities;

  return (
    <DataFetcher
      request={useImagesSection(props.productId)}
      Error={() => null}
      View={ProductTileImageSliderView}
      viewProps={props}
      Loading={Skeleton}
      computeDefaultState={() => {
        if (props.skipDefaultState) {
          return;
        }

        if (isProductTileEntities(entities)) {
          const {badges, product} = entities;

          return {
            badges,
            product,
          } as ImagesSection;
        }

        return undefined;
      }}
    />
  );
};

const Skeleton = () => {
  return (
    <>
      <SkeletonBlock $width="100%" $height="300px" />
      <SkeletonBlock $width="100%" $height="50px" />
    </>
  );
};
